import { Container } from "react-bootstrap";
import { useEffect } from "react";
import "./AccessDenied.css"

const AccessDenied = () => {
    useEffect(() => {
        document.body.classList.add("body-denied");

        return () => {
            document.body.classList.remove("body-denied");
        };
    }, []);

    return (
        <Container className="container-denied">
            <div className="content-denied">
                <div className="panel-heading-denied">
                    <h3>Access denied</h3>
                </div>
                <div className="panel-body-denied">
                    <div className="dy-notauthorized">You are not authorized to access to this Portal.</div>
                </div>
            </div>
        </Container>
    )
};

export default AccessDenied;
